import React from "react";
import PropTypes from "prop-types";
import TextBlock from "../text/TextBlock";

/**
 * ImageBlock: props => React element
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * Image block renderer
 *
 * @param {*} props
 */
const ImageBlock = props => (
  <div>
    {props.isReadOnlyMode ? (
      <img src={props.block.url} alt="" className="manuscript-image" />
    ) : (
      <TextBlock
        {...props}
        placeholder={"manuscript.blocks.image.placeholder"}
        dataKey={"url"}
      />
    )}
  </div>
);

ImageBlock.propTypes = {
  /**
   * block: {url}
   * Contains the content block information
   */
  block: PropTypes.shape({
    url: PropTypes.string
  }).isRequired,

  /**
   * isReadOnlyMode: Boolean
   * True if the block is read-only
   */
  isReadOnlyMode: PropTypes.bool.isRequired,

  /**
   * onChange: updatedBlock => ()
   * Passes on a block update to the higher-level component
   */
  onChange: PropTypes.func.isRequired
};

export default ImageBlock;



// WEBPACK FOOTER //
// ./src/modules/editor/manuscript/blocks/media/ImageBlock.js